/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableFooter,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Switch,
  IconButton,
} from "@mui/material";
import { faCheck, faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import baseUrl from "../../Environment";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { RotatingLines } from "react-loader-spinner";
const UserManagement = () => {
  const [userAdmin, setUserAdmin] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loggedInUserRole, setLoggedInUser] = useState("");
  const [role, setRole] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [actionType, setActionType] = useState("edit"); // "edit" or "delete"
  const [isEdit, setIsEdit] = useState(false);
  const [Loading, setLoading] = useState(false);
  // Load logged-in user
  const phoneNumber = localStorage.getItem("phoneNumber");
  const LoadUser = async () => {
    try {
      const response = await axios.get(`${baseUrl}user/get/${phoneNumber}`);
      const data = response.data;
      if (data && data.user && data.user.users) {
        const loggedInUser = data.user.users[0];
        if (loggedInUser && loggedInUser.role) {
          setLoggedInUser(loggedInUser.role); // Update the state
        }
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const LoadAdmins = async () => {
    setLoading(true);
    try {
      const response = await axios.get(baseUrl + "user/allusers");
      const data = response.data;
      if (data && data.length > 0) {
        const allUsers = data.flatMap((admin) => admin.users);
        setUserAdmin(allUsers);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const exportToExcel = () => {
    if (userAdmin.length === 0) {
      alert("No data to export");
      return;
    }
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Users");

    // Add headers and apply styles
    const headers = Object.keys(userAdmin[0]);
    worksheet.addRow(headers);

    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    // Add data rows
    userAdmin.forEach((user) => {
      worksheet.addRow(Object.values(user));
    });

    // Adjust column widths
    headers.forEach((header, index) => {
      worksheet.getColumn(index + 1).width = header.length + 5; // Adjust width dynamically
    });

    // Generate and save the file
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(new Blob([buffer]), "users_data.xlsx");
    });
  };

  useEffect(() => {
    LoadUser();
    LoadAdmins();
  }, []);
  useEffect(() => {
    // console.log("Logged in user role:", loggedInUserRole);
  }, [loggedInUserRole]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleRoleRange = (e) => {
    setRole(e.target.value);
  };
  const toggleStatus = () => {
    setSelectedUser((prev) => ({ ...prev, status: !prev.status }));
  };
  const canEdit = (targetRole) => {
    if (loggedInUserRole === "SUPER ADMIN") {
      return true; // SUPER ADMIN can edit any user
    }
    if (loggedInUserRole === "ADMIN" && targetRole !== "SUPER ADMIN") {
      return true; // ADMIN can edit other ADMINs and GENERAL users
    }
    return false; // GENERAL users cannot edit anyone
  };

  const canDelete = (targetRole) =>
    loggedInUserRole === "SUPER ADMIN" && targetRole !== "SUPER ADMIN";

  const openConfirmationDialog = (user, type) => {
    // Only show the dialog if the action is delete
    if (type === "delete") {
      setSelectedUser(user);
      setRole(user.role);
      setActionType(type);
      setOpenDialog(true);
    }
  };
  const handleConfirmAction = async () => {
    if (!selectedUser) return;

    try {
      const updatedUser = { ...selectedUser, role };
      if (actionType === "edit") {
        await axios.put(`${baseUrl}user/update/${selectedUser.userId}`, {
          status: updatedUser.status,
          role: role,
        });
        setUserAdmin((prevUsers) =>
          prevUsers.map((user) =>
            user.userId === selectedUser.userId
              ? { ...user, status: updatedUser.status, role: updatedUser.role }
              : user
          )
        );
      } else if (actionType === "delete") {
        await axios.delete(`${baseUrl}user/delete/${selectedUser.userId}`);
        setUserAdmin((prevUsers) =>
          prevUsers.filter((user) => user.userId !== selectedUser.userId)
        );
      }

      handleCloseDialog();
    } catch (error) {
      console.error(`Error performing ${actionType} action:`, error);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedUser(null);
    setActionType("");
    setIsEdit(false);
  };

  const shouldShowActions =
    loggedInUserRole === "SUPER ADMIN" || loggedInUserRole === "ADMIN";

  return (
    <div>
      {Loading ? (
        <div
          className="relative h-[100vh] border-t-2 flex items-center justify-center"
          style={{ position: "relative", height: "100vh" }}
        >
          <div
            className=" flex items-center justify-center"
            style={{
              position: "absolute",
              height: "100vh",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <RotatingLines
              visible={true}
              height="150"
              width="150"
              color="red"
              strokeColor="#24425a"
              strokeWidth="5"
              animationDuration="0.75"
              ariaLabel="rotating-lines-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        </div>
      ) : (
        <div className="p-2 " style={{ height: "85vh", overflowY: "auto" }}>
          <div className="flex justify-between items-center px-3 mt-3 py-1 bg-primary">
            <h5 className="  text-white" style={{ margin: "0" }}>
              Users
            </h5>
            {shouldShowActions && (
              <Button
                size="small"
                className="bg-white gap-2 text-[black] text-xl"
                style={{ color: "gray", fontWeight: "bold" }}
                onClick={exportToExcel}
              >
                <i className="bi bi-file-earmark-fill"></i> Export to Excel
              </Button>
            )}
          </div>
          <TableContainer component={Paper} className="userContainer">
            <Table className="userTable">
              <TableHead className="thead-box">
                <TableRow style={{ borderBottom: "2px solid gray" }}>
                  <TableCell style={{ fontWeight: "bold", fontSize: "18px" }}>
                    #
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", fontSize: "18px" }}>
                    Name
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", fontSize: "18px" }}>
                    Email
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", fontSize: "18px" }}>
                    Role
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold", fontSize: "18px" }}>
                    Status
                  </TableCell>
                  {shouldShowActions && (
                    <TableCell
                      style={{
                        fontWeight: "bold",
                        fontSize: "18px",
                        paddingLeft: "40px",
                      }}
                    >
                      Action
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody className="userBody">
                {userAdmin
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((user, index) => (
                    <TableRow
                      key={user.userId}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#f2f2f2" : "#ffffff", // Alternating colors
                        height: "10px !important",
                        padding: "0px !important",
                      }}
                      sx={{
                        padding: "0px",
                      }}
                    >
                      <TableCell>{index + 1 + page * rowsPerPage}.</TableCell>
                      <TableCell>{user.name || "N/A"}</TableCell>
                      <TableCell>{user.email}</TableCell>
                      <TableCell
                        id="usermanagement"
                        className="targettingCell"
                        style={{
                          padding: "10px !important",
                        }}
                      >
                        {isEdit && selectedUser?.userId === user.userId ? (
                          <select
                            value={role}
                            onChange={handleRoleRange}
                            className="sm:w-42 lg:w-36 p-1 rounded-lg"
                            style={{
                              margin: "10px !important",
                            }}
                          >
                            <option value="ADMIN">Admin</option>
                            <option value="GENERAL">General</option>
                            {loggedInUserRole === "SUPER ADMIN" ? (
                              <option value="SUPER ADMIN">Super Admin</option>
                            ) : (
                              ""
                            )}
                          </select>
                        ) : (
                          user.role
                        )}
                      </TableCell>
                      <TableCell>
                        {isEdit && selectedUser?.userId === user.userId ? (
                          <Switch
                            checked={selectedUser.status}
                            onChange={toggleStatus}
                            sx={{
                              "& .MuiSwitch-switchBase.Mui-checked": {
                                color: "green", // Customize the thumb color when checked
                              },
                              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                {
                                  backgroundColor: "green", // Customize the track color when checked
                                },
                              "& .MuiSwitch-switchBase": {
                                color: "red", // Customize the thumb color when unchecked
                              },
                              "& .MuiSwitch-switchBase + .MuiSwitch-track": {
                                backgroundColor: "red", // Customize the track color when unchecked
                              },
                            }}
                          />
                        ) : (
                          <Switch
                            checked={user.status}
                            sx={{
                              "& .MuiSwitch-switchBase.Mui-checked": {
                                color: "green", // Customize the thumb color when checked
                              },
                              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                {
                                  backgroundColor: "green", // Customize the track color when checked
                                },
                              "& .MuiSwitch-switchBase": {
                                color: "red", // Customize the thumb color when unchecked
                              },
                              "& .MuiSwitch-switchBase + .MuiSwitch-track": {
                                backgroundColor: "red", // Customize the track color when unchecked
                              },
                            }}
                          />
                        )}
                      </TableCell>

                      {/* Show action buttons for Admins and SUPER ADMINs */}
                      {shouldShowActions && (
                        <TableCell
                          style={{
                            display: "flex",
                            gap: "10px",
                          }}
                          className="actions"
                        >
                          {canEdit(user.role) && (
                            <>
                              <IconButton
                                color="success"
                                size="small"
                                sx={{
                                  border: "none",
                                }}
                                onClick={() => {
                                  if (
                                    isEdit &&
                                    selectedUser?.userId === user.userId
                                  ) {
                                    handleConfirmAction();
                                  } else {
                                    setSelectedUser(user);
                                    setRole(user.role);
                                    setIsEdit(true);
                                    setActionType("edit");
                                  }
                                }}
                              >
                                {isEdit &&
                                selectedUser?.userId === user.userId ? (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    className="text-[#1ccaff]"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    icon={faPen}
                                    className="text-[green]"
                                  />
                                )}
                              </IconButton>
                              {canDelete(user.role) && (
                                <IconButton
                                  variant="text"
                                  color="error"
                                  size="small"
                                  onClick={() =>
                                    openConfirmationDialog(user, "delete")
                                  }
                                >
                                  <FontAwesomeIcon
                                    icon={faTrash}
                                    className="text-[red]"
                                  />
                                </IconButton>
                              )}
                            </>
                          )}
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
              </TableBody>

              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    count={userAdmin.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    className="actions"
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
          <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Delete User</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to delete this user?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialog} color="secondary">
                Cancel
              </Button>
              <Button onClick={handleConfirmAction} color="primary" autoFocus>
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </div>
  );
};

export default UserManagement;
